import React, {Component} from 'react';
import ReviewOfSystemPartial from '../patientPartials/ReviewOfSystemPartial';

class ReviewOfSystem extends Component {
  render() {
    return(
        <ReviewOfSystemPartial patientId={this.props.patientId}/>
    );
  }
}

export default ReviewOfSystem;